import { render, staticRenderFns } from "./PostAttachModal.vue?vue&type=template&id=3fb10406"
import script from "./PostAttachModal.vue?vue&type=script&lang=js"
export * from "./PostAttachModal.vue?vue&type=script&lang=js"
import style0 from "./PostAttachModal.vue?vue&type=style&index=0&id=3fb10406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports